import Link from 'next/link';
import { Divider } from '..';
import ItemRightTableList from '../RightTableList/ItemRightTableList';
import { IPostCardProps } from '@/interfaces/card';

interface IRightTableThreeItemList {
  category?: {
    pathFullSlug?: {
      fullSlug?: string | null;
    } | null;
    name?: string | null;
  };
  data?: IPostCardProps[];
}

const RightTableThreeItem = ({ data, category }: IRightTableThreeItemList) => {
  return (
    <div className="rounded-xl bg-[#E4E4E4] p-5 w-full">
      <Link
        href={`/${category?.pathFullSlug?.fullSlug}`}
        className="block text-center text-[24px] font-bold pb-4"
      >
        {category?.name}
      </Link>
      <div className="flex flex-col">
        <ItemRightTableList {...data?.[0]} />
        {data?.[1] ? (
          <>
            <Divider />
            <Link
              href={`/${data?.[1]?.category?.slug}/${data?.[1]?.slug}-${data?.[1]?.id}`}
              className="text-[16px] font-bold line-clamp-3 h-fit"
            >
              {data?.[1]?.title}
            </Link>
          </>
        ) : (
          <></>
        )}
        {data?.[1] ? (
          <>
            <Divider />
            <Link
              href={`/${data?.[1]?.category?.slug}/${data?.[1]?.slug}-${data?.[1]?.id}`}
              className="text-[16px] font-bold line-clamp-3 h-fit"
            >
              {data?.[2]?.title}
            </Link>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default RightTableThreeItem;
